// imove-branch: 判断页面是否需要检查登录

const isWemeetApp = () => {
  if (typeof wemeet !== 'undefined') {
    const { app } = wemeet;
    return app.isTMWebview();
  }
  return false;
};

export default async function(ctx) {
    const { pathname } = ctx.getPipe();
    const { NO_NEED_LOGIN_PAGES = [] } = ctx.payload;
    const needAuthPath = NO_NEED_LOGIN_PAGES.indexOf(pathname) === -1;
    const isWemeet = isWemeetApp();
    const needCheckLogin = isWemeet || needAuthPath; // 需要登录
    if (!needCheckLogin) {
        return false;
    }
    return true;
}